import React from 'react';
import { Box, Group, Stack, Text } from '@mantine/core';

export interface AfaCommentBoxProps {
  /** Nombre del autor del comentario */
  author: string;
  
  /** Fecha de creación del comentario */
  date: string;
  
  /** Contenido del comentario */
  content: string;
  
  /** Color de fondo del box */
  backgroundColor?: string;
  
  /** Padding del box */
  padding?: string | number;
  
  /** Border radius del box */
  borderRadius?: string | number;
  
  /** Estilos CSS personalizados */
  style?: React.CSSProperties;
}

/**
 * AfaCommentBox - Componente para mostrar comentarios con autor, fecha y contenido
 * 
 * Componente responsive que muestra un comentario con su metadata (autor y fecha).
 * El layout se adapta automáticamente: en pantallas grandes muestra autor y fecha
 * en la misma línea, mientras que en móvil se apilan verticalmente.
 * 
 * @example
 * <AfaCommentBox 
 *   author="Nom de l'autor"
 *   date="Data de creació"
 *   content="Lorem ipsum dolor sit amet, consectetur adipiscing elit..."
 * />
 */
export const AfaCommentBox = ({
  author,
  date,
  content,
  borderRadius = '8px',
  style,
}: AfaCommentBoxProps) => {
  return (
    <Box
      style={{ 
        borderRadius,
        ...style 
      }}
    >
      <Stack gap={4}>
        {/* Header: Autor y Fecha - Responsive */}
        <Group 
          justify="space-between" 
          align="flex-start"
          style={{
            flexDirection: 'row',
            '@media (maxWidth: 768px)': {
              flexDirection: 'column',
              gap: '4px'
            }
          }}
        >
          <Text size="sm" fw={600}>
            {author}
          </Text>
          <Text size="sm">
            {date}
          </Text>
        </Group>
        
        {/* Contenido del comentario */}
        <Text size="md" fw={400} style={{ lineHeight: 1.2 }}>
          {content}
        </Text>
      </Stack>
    </Box>
  );
};

export default AfaCommentBox;
